export const register = {
  title: 'Kostenlos registrieren',
  registerButton: 'Jetzt registrieren',
  register: 'Registrieren',
  registrationFailed: 'Registration fehlgeschlagen',
}
